<template>
    <base-dropdown
        ref="dropdown"
        placement="bottom-start"
        @open="onOpen"
    >
        <button
            slot="trigger"
            slot-scope="{ open }"
            type="button"
            class="focus:outline-none focus:outline-shadow"
            @click.prevent="open"
        >
            <slot name="trigger" />
        </button>

        <div
            slot="menu"
            class="max-w-xs px-2 py-1 text-sm dropdown-menu mt-3px"
        >
            <slot name="tooltip" />
        </div>
    </base-dropdown>
</template>

<script>
    export default {
        props: {
            closeAfter: {
                type: Number,
                default: 0
            }
        },
        methods: {
            onOpen () {
                // this.$emit('open')

                if (this.closeAfter < 1) {
                    return
                }

                setTimeout(() => {
                    this.$refs.dropdown.close()

                    // this.$emit('close')
                }, this.closeAfter)
            }
        }
    }
</script>
